import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
    en: {
        about: 'About',
        alias: 'Alias',
        amount: 'Amount',
        available: 'available',
        availableCredits: 'Available Credits',
        addHostServer: 'Add a Host / Server',
        addToCart: 'Add To Cart',
        back: 'Back',
        browseConfigurationFile: 'Drop file here, or <u>browse</u> to upload file',
        cancel: 'Cancel',
        changeItAt: 'Change it at',
        checkout: 'Checkout',
        chooseAProduct: 'Choose a product to configure',
        chooseDate: 'Choose date',
        close: 'Close',
        remove: 'Remove',
        configureThisProduct: 'Configure this product',
        confirmation: 'Confirmation',
        contact: 'Contact',
        contactForHelp: 'Please contact Siemens for help.',
        continueShopping: 'Continue Shopping',
        contractDuration: 'Contract duration',
        creditsSeat: 'Credits/seat',
        creditsUsed: 'Credits Used',
        credits: 'Credits',
        creditsUtilized: 'Credits Utilized',
        currency: 'Currency',
        currentFavorite: 'Current favorite',
        configurationUploaded:
            'Configuration file uploaded successfully. Please click show validation success message link below',
        complete: "complete",
        configureAProductWithTemplate: 'Configure products with a template',
        configurationTemplate: 'Consumption Template',
        date: 'Date',
        dealId: 'Deal ID',
        description: 'Description',
        downloadTransactions: 'Download all as Excel',
        downloadValidationErros: 'Download Validation Errors',
        duration: 'Duration',
        durationOverflow: 'Your deal will end before this date.',
        danger: 'danger',
        days: 'Days',
        dragOnlyExcelFiles:
            'Configuration data must be in Excel format. Please use a file with extension .xlsm',
        downloadConfigurationProductList: 'Download current configuration & product list',
        enableUserSpoofing: 'Enable user spoofing',
        enterSpecialInstructions:
            'Please enter any notes for this order here. (Note: they are for your own internal usage and will not be reviewed on fulfillment).',
        faq: 'FAQ',
        favorite: 'Favorite',
        favoriteThisServer: 'Favorite this server',
        forgotPassword: 'Forgot your password?',
        fulfilledOn: 'Fulfilled on',
        failedValidation: 'Show Validation Failed message',
        help: 'Help',
        history: 'History',
        info: 'info',
        InsufficientFunds: ' Insufficient Funds',
        lastLogin: 'Last login',
        lastTransaction: 'Last Transaction',
        licenses: 'Licenses',
        loggedInAs: 'Logged in as',
        login: 'Login to Siemens Advantage',
        loginHelp0:
            'Siemens Advantage now uses your Support Center password for authentication. This allows you to manage your own password, as well as gives you a single password to remember for every Siemens web property.',
        loginHelp1:
            "If you are a new Siemens Advantage user, you'll start by using your Support Center password. If you've used Siemens Advantage before and were logging in with a non-email username and password that was assigned to you, you can use the following form to map your old username to a Support Center account.",
        loginHelp2:
            "Enter your old Siemens Advantage username below, then click 'Submit.' We'll email you your Support Center username, as well as instructions for using it.",
        lookup: 'Look up username',
        mentorAdvantage: 'Advantage',
        mentorId: 'Siemens ID',
        message: 'Message',
        messageSent: 'Message sent.',
        monthAbbr: 'mo',
        months: 'Months',
        myAccount: 'My Account',
        myBalance: 'My balance',
        myMentorContact: 'My Siemens Contact',
        myProfile: 'My Profile',
        mapDowntime: "MAP PORTAL SCHEDULED DOWNTIME",
        needHelpQuestion: 'Need help?',
        needLoginHelp: 'Need help logging in?',
        nickname: 'Nickname',
        no: 'No',
        noOffersAvailable: 'You have no deals available.',
        notes: 'Notes',
        noUserRecord: "You don't have a Siemens Advantage user record.",
        noUserRecordExplanation:
            "While you entered your Support Center username and password correctly, you can't be logged in to the Siemens Advantage portal. You don't have a user record in the Siemens Advantage system. Please contact your Siemens representative to have them create a user record for you. After your user record has been created, close this window and log in again.",
        none: 'None',
        notFulfilled: 'Not fulfilled yet.',

        order: 'Order',
        yourCart: 'Your Cart',
        orderDate: 'Order date',
        orderFailed:
            'Your order could not be submitted. Please try again in a few minutes.',
        orderFailedTitle: 'Order Submit failed.',
        orderHelp: 'If you continue to have problems, please contact Siemens.',
        orderSubmitted: 'Order submitted.',
        orderedOn: 'Ordered on',
        placeOrder: 'Place order',
        pricing: 'Pricing',
        pricingForOffer: 'Pricing for deal',
        printHeader: 'Siemens Advantage - Receipt',
        printReceipt: 'Print Receipt',
        product: 'Product',
        partNumber: 'PN',
        profile: 'Profile',
        reallyCancel: 'Do you really want to cancel this order?',
        regardingOrder: 'Regarding Siemens Advantage order from',
        remaining: 'Remaining',
        requestSent: 'Request sent. Check your email for further details.',
        retain: 'Retain',
        reviewCart: 'Shopping Cart',
        reviewYourOrder:
            'Please review your order and make any necessary changes.',
        seat: 'Seat',
        seats: 'Seats',
        selectAProduct: 'Please select a product to configure',
        selectSiteForNewServer: 'Select the Site for new server',
        sendMessage: 'Send message',
        sendingRequest: 'Sending request...',
        server: 'Server',
        serverId: 'Server ID',
        serversFor: 'Servers for',
        signOut: 'Sign out',
        site: 'Site',
        siteId: 'Site ID',
        sites: 'Sites',
        specialInstructions: 'Special Instructions',
        spoof: 'Spoof',
        spoofing: 'Spoofing...',
        startDate: 'Start date',
        endDate: 'End date',
        startTheTour:
            'This looks like your first time using the new and improved Siemens Advantage. Would you like to take a tour?',
        startTour: 'Start Tour',
        subject: 'Subject',
        submitOrder: 'Submit order',
        submitOrderQuestion: 'Submit this order?',

        confirmOrderQuestion: 'Confirm Order Submission',
        submittingOrder: 'Submitting order.',
        submit: 'Submit',
        siteIdRequired:
            'Please select Site and provide a Host and/or Server ID',
        serverOrHostRequired: 'Please provide a Host and/or Server ID',
        subtotal: 'Subtotal',
        success: 'success',
        successValidation: 'Show Validation Success message',
        ServersBySite: 'ServersBySite',
        ServersBySiteList: 'Download all Servers as Excel',
        saveAndContinueShopping: 'Save & Continue Shopping',
        saveForLater: 'Save For Later',
        takeTour:
            'Click the button below to restart the Siemens Advantage tour.',
        total: 'Total',
        totalCredits: 'Total credits',
        tour: 'Tour',
        transactionReportFilename: 'Siemens Advantage Transactions For Deal',
        transactions: 'Transactions',
        unknownPlatform: 'Unknown platform',
        user: 'User',
        username: 'Username',
        uploadNewConfiguration: 'Upload new configuration',
        uploadedConfiguration:
            'Uploading configuration file. Please wait .....',
        uploading: 'Uploading...',
        uploadError: 'There was a problem during upload. Please try again',
        uploadConfigurationProductList: 'Upload New Configuration',
        version: 'Version',
        weekAbbr: 'wk',
        weekly: 'Weekly',
        weeks: 'Weeks',
        welcome: 'Welcome to Siemens Advantage',
        warning: 'warning',
        yes: 'Yes',
    },
});

export default strings;



// WEBPACK FOOTER //
// ./app/strings.js